import React from 'react';
import styles from './EnergyBillReconcilliation_Bus.module.css'
import DashboardMain_Bus from '../DashboardMain_Bus/DashboardMain_Bus';
import { useCallback, useEffect, useState } from "react";
import { INIT_FILTER_STATE, API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../hook/use-http'
import TabularData_Bus from './TabularData_Bus';
import EnergyBillReconcilliation_Filters_Bus from './EnergyBillReconcilliation_Filters_Bus';
import { decodeToken } from 'react-jwt';

export default function EnergyBillReconcilliation_Bus() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE

  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const log_data = () => ""

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "EnergyBillReconcilliation_Bus"
      }
    }, log_data)
  }, []);

  const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);
  const filterSubmited = useCallback((data) => {
    if (data.VIN_NUM.length === 1) {
      setFromTableToFilter_vin(data.VIN_NUM[0])
    }
    setGloablfilter(data);
  }, []);

  const onreset = (data) => {
    setGloablfilter(data);
  }

  const arr = [
    { title: "Tabular Data View", apiEndPoint: "tableDataDrive_tableDataEnergy" },
  ]

  return (
    <>
      <DashboardMain_Bus>
        <div className={`${styles.main_hole_background} pb-2`}>
          <EnergyBillReconcilliation_Filters_Bus onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} fromTableToFilter_vin={fromTableToFilter_vin} />
          <div className="container-fluid">

            <div className="row d-flex justify-content-end">
              {
                arr.map((item, index) => {
                  let key = `item_${index}`;
                  return (<TabularData_Bus key={key} gloablfilter={gloablfilter} extraThings={item} />)
                })
              }
            </div>
          </div>
        </div>
      </DashboardMain_Bus>
    </>
  )
}